import Box from '@totallymoney/ui/components/Box'
import Text from '@totallymoney/ui/components/Text'
import GuaranteedBadge from '@totallymoney/ui/productTable/components/GuaranteedBadge'

import {
    StyledHeading,
    StyledLoansTableItemProductDetail,
} from './LoansTableItemProductDetail.styled'

const LoansTableItemProductDetail = ({
    title,
    value,
    showGuaranteedBadge = false,
}: {
    showGuaranteedBadge?: boolean
    title: string
    value: string | number
}) => (
    <StyledLoansTableItemProductDetail
        display="flex"
        flexDirection={['unset', 'column']}
        alignItems="flex-start"
        justifyContent="space-between"
    >
        <Box mb={[0, 'space10']}>
            <Text variant="100" color="light">
                {title}
            </Text>
        </Box>

        <Box>
            {typeof value === 'string' ? (
                <StyledHeading variant="40" color="light">
                    {value}
                </StyledHeading>
            ) : (
                value
            )}

            {showGuaranteedBadge ? (
                <Box
                    position={['relative', 'absolute']}
                    mt="space05"
                    display="flex"
                    justifyContent="flex-end"
                >
                    <GuaranteedBadge />
                </Box>
            ) : null}
        </Box>
    </StyledLoansTableItemProductDetail>
)

export default LoansTableItemProductDetail
